import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Practice, AuthState } from '../../types';


const initialState: AuthState = {
  token: null,
  practice: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    startInit(state) {
      state.loading = true;
      state.error = null;
    },
    initSuccess(
      state,
      action: PayloadAction<{ token: string; practice: Practice }>
    ) {
      state.loading = false;
      state.token = action.payload.token;
      state.practice = action.payload.practice;
    },
    initFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.token = null;
      state.practice = null;
    },
    clearAuth(state) {
      state.token = null;
      state.practice = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const { startInit, initSuccess, initFailure, clearAuth } = authSlice.actions;
export default authSlice.reducer;





